import React from 'react'
import cn from 'classnames'

import styles from './Loading.module.css'

const Loading = ({ show = false }: { show: boolean }): JSX.Element => {
  return (
    <div
      className={cn(styles.overlay, {
        [styles.show]: show,
      })}
    />
  )
}

export default Loading
